import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';

@Component({
  standalone: true,
  imports: [
    MatCard,
    MatButton,
    MatIcon
  ],
  selector: 'equine-ui-nx-empty-cart',
  templateUrl: './empty-cart.component.html',
  styleUrls: ['./empty-cart.component.scss']
})
export class EmptyCartComponent {

  @Input() hasPending = false;
  @Output() clicked = new EventEmitter<void>();
  @Output() verificationClicked = new EventEmitter<void>();

  goToDashboard(){
    this.clicked.emit();
  }

  verifyPending() {
    this.verificationClicked.emit();
  }


}
